<app-nav-menu *ngIf="isShowMenu"></app-nav-menu>
<div *ngIf="!isClientContract" [ngClass]="isMembership ? 'mem-section' : ''">
    <div class="wrapper-main">
        <div *ngIf="isShowMenu">
            <div class="left-side-section" *ngIf="!isContract">
                <app-left-side-menu *ngIf="isCmManager"></app-left-side-menu>
                <app-mem-left-side-menu *ngIf="isMembership"></app-mem-left-side-menu>
                <app-location-left-menu *ngIf="isCmSite"></app-location-left-menu>
            </div>
        </div>
        <div [ngClass]="{'right-side-section-contract': isContract  ,'right-side-section':isCmManager ||  isCmSite, 'mem-contact-panel' :isMembership}">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<div *ngIf="isClientContract">
    <div>
        <router-outlet></router-outlet>
    </div>
</div>

